// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__mGNAF","Logo":"Header_Logo__BCqeH","SelectedMenu":"Header_SelectedMenu__JOI+f"};